<template>
  <router-link :to="'/course/' + item.id">
    <img
      :src="base_url + item.image"
      class="card-img-top"
      alt="">
    <div class="card-body">
      <p class="card-text"><rating/> <span>{{item.nr_view}}</span></p>
      <h5 class="card-title">{{ item.name }}</h5>
    </div>
  </router-link>
</template>

<script>
  import rating from '../include/rating'
  import ApiConfig from '../../communicate/ApiConfig'

  export default {
    name: 'CourseItem2',
    components: {
      rating: rating
    },

    // eslint-disable-next-line vue/require-prop-types
    props: ['item'],
    data: function() {
      return {
        base_url: ApiConfig.base_url
      }
    },

    methods: {

    }
  }
</script>

<style scoped>
    .card-title{
    font-size: 1rem;
    color: #000;
    margin-bottom: 0;
    }
    .card-title:hover{
    text-decoration: none;
    }
    .card-text{
        display: flex;
        width: 100%;
    }
    .card-text span{
        color: #000;
        margin-left: 10px;
        font-size: 1rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/course/CourseItem2.vue